import CourseActions from '@/content/actions/course.actions';
import CourseMutations from '@/content/mutations/course.mutations';
import ComponentActions from '@/content/actions/component.actions';
import { SECTION_OPTION_MODE } from '@/courses/values/courses.values';
import { _COURSE_STORE } from '@/courses/values/courses.values';

export const COURSE_STORE = _COURSE_STORE;

export const CourseStore = {
  namespaced: true,
  state: {

    /* Course items */
    coursesAlreadyLoad: false,
    sectionOpenedMode: SECTION_OPTION_MODE.COMMON,
    hasObjectSelected: false,
    movingObject: false,

    /* Courses */
    courses: {
      content: [],
      more: false,
      page: 0,
      pageSize: 300
    },

    /* This data was used for import content */ 
    /* materialsOptions: [],
    materialsOptionsUsed: [],
    hasMoreMaterials: false,
    pageMaterialSize: 15,
    pageMaterial: 0, */
    isPresentationTeacherMode: false,
    isPresentationStudentMode: false,
    presentationCourseSelected: 0,
    // Zoom pdf files
    zoomObject: true,
    isSplitHorizontal: false,
    isSplitVertical: false,
    pdfLoading: true,
    showSectionPersonCourseViewer: false,
    imagesLoading: true,
    videoLoading: true,
    isBoardSectionHomework: false,
    currentCardInfo: {
      isFrontSide: true,
      card: {},
      index: 0
    },
    currentMenuOptions: {},
    sectionToEdit: null,
    eduacComponentSelected: {},
  },
  mutations: {
    setCourseInfo: CourseMutations.setCourseInfo,
    setCourseContent: CourseMutations.setCourseContent, /* Deprecated */
    updateOrderSections: CourseMutations.updateOrderSections,
    updateSection: CourseMutations.updateSection,
    updateMaterialSection: CourseMutations.updateMaterialSection,  /* Deprecated */
    createObject: CourseMutations.createObject, /* Deprecated */
    createSection: CourseMutations.createSection,
    removeSection: CourseMutations.removeSection,
    removeCourseMaterial: CourseMutations.removeCourseMaterial,
    removeCourseMaterialSection: CourseMutations.removeCourseMaterialSection,
    importCourseMaterial: CourseMutations.importCourseMaterial, /* Deprecated */
    setCourses: CourseMutations.setCourses,
    setPreviewSelected: CourseMutations.setPreviewSelected,
    setCourseMaterial: CourseMutations.setCourseMaterial,
    updateCourseMaterial: CourseMutations.updateCourseMaterial,
    setCourseMaterialSection: CourseMutations.setCourseMaterialSection,
    setContentForCourse: CourseMutations.setContentForCourse,
    setStudentsInCourse: CourseMutations.setStudentsInCourse, /* Deprecated */
    setTeacherOnlySection: CourseMutations.setTeacherOnlySection,
    updateMaterialSectionName: CourseMutations.updateMaterialSectionName,
    setComponentSelected: CourseMutations.setComponentSelected,
    setCourseMode: CourseMutations.setCourseMode,
    setMovingObject: CourseMutations.setMovingObject,
    setPresentationTeacherMode: CourseMutations.setPresentationTeacherMode,
    setPresentationStudentMode: CourseMutations.setPresentationStudentMode,
    updatePresentationCourseSelected: CourseMutations.updatePresentationCourseSelected,
    setPresentationCourses: CourseMutations.setPresentationCourses,
    setZoomObject: CourseMutations.setZoomObject,
    isSplitHorizontal: CourseMutations.isSplitHorizontal,
    isSplitVertical: CourseMutations.isSplitVertical,
    setPdfLoading: CourseMutations.setPdfLoading,
    setCompletedTaskBySection: CourseMutations.setCompletedTaskBySection,
    setShowSectionPersonCourseViewer: CourseMutations.setShowSectionPersonCourseViewer,
    setImagesLoading: CourseMutations.setImagesLoading,
    setVideoLoading: CourseMutations.setVideoLoading,
    setGradingDetailsForCourse: CourseMutations.setGradingDetailsForCourse,
    createProject: CourseMutations.createProject,
    updateProject: CourseMutations.updateProject,
    removeProject: CourseMutations.removeProject,
    updateOrderProjects: CourseMutations.updateOrderProjects,
    saveProjectFiles: CourseMutations.saveProjectFiles,
    setIsBoardSectionHomework: CourseMutations.setIsBoardSectionHomework,
    revertSectionMoved: CourseMutations.revertSectionMoved,
    removeSectionFromParent: CourseMutations.removeSectionFromParent,
    addComponent: CourseMutations.addComponent,
    setComponent: CourseMutations.setComponent,
    deleteComponent: CourseMutations.deleteComponent,
    createDeck: CourseMutations.createDeck,
    updateDeck: CourseMutations.updateDeck,
    removeDeck: CourseMutations.removeDeck,
    refreshDeck: CourseMutations.refreshDeck,
    createCard: CourseMutations.createCard,
    updateCard: CourseMutations.updateCard,
    removeCard: CourseMutations.removeCard,
    setCurrentCardInfo: CourseMutations.setCurrentCardInfo,
    setCurrentMenuOptions: CourseMutations.setCurrentMenuOptions,
    initState: CourseMutations.initCourseState,
    resetSectionToEdit: CourseMutations.resetSectionToEdit,
    setEduacComponentSelected: CourseMutations.setEduacComponentSelected
  },
  actions: {
    addCourseMaterial: CourseActions.addCourseMaterial,
    removeCourseMaterial: CourseActions.removeCourseMaterial,
    getCourseInfo: CourseActions.getCourseInfo,
    getContentByEditor: CourseActions.getContentByEditor,
    getCourses: CourseActions.getCourses,
    removeImgFromSection: CourseActions.removeImgFromSection,
    updateSection: CourseActions.updateSection,
    createSection: CourseActions.createSection,
    reorderSection: CourseActions.reorderSection,
    removeFile: CourseActions.removeFile,
    removeSection: CourseActions.removeSection,
    createSectionFromObject: CourseActions.createSectionFromObject,
    copySection: CourseActions.copySection,
    createCourseMaterialSection: CourseActions.createCourseMaterialSection,
    updateSectionMaterial: CourseActions.updateSectionMaterial,
    removeSectionMaterial: CourseActions.removeSectionMaterial,
    updateCourseMaterialSection: CourseActions.updateCourseMaterialSection,
    moveCourseMaterial: CourseActions.moveCourseMaterial,
    moveCourseMaterialSection: CourseActions.moveCourseMaterialSection,
    createWriteObject: CourseActions.createWriteObject,
    updateWriteObject: CourseActions.updateWriteObject,
    updateCourseMaterial: CourseActions.updateCourseMaterial,
    updateSectionMaterialVisibility: CourseActions.updateSectionMaterialVisibility,
    updateCourseFilesIfInfoReady: CourseActions.updateCourseFilesIfInfoReady,
    updateCourseMaterialIfInfoReady: CourseActions.updateCourseMaterialIfInfoReady,
    updateFile: CourseActions.updateFile,
    rotateContentAsset: CourseActions.rotateContentAsset,
    getContentForCourse: CourseActions.getContentForCourse,
    setTeacherOnlySection: CourseActions.setTeacherOnlySection,
    getPresentationCourses: CourseActions.getPresentationCourses,
    getCompletedTaskByStudent: CourseActions.getCompletedTaskByStudent,
    getGradingDetailsForCourse: CourseActions.getGradingDetailsForCourse,
    createProject: CourseActions.createProject,
    updateProject: CourseActions.updateProject,
    removeProject: CourseActions.removeProject,
    reorderProject: CourseActions.reorderProject,
    saveProjectFiles: CourseActions.saveProjectFiles,
    getCourseEdition: CourseActions.getCourseEdition,
    createComponent: ComponentActions.createComponent,
    updateComponent: ComponentActions.updateComponent,
    removeComponent: ComponentActions.removeComponent,
    createDeck: CourseActions.createDeck,
    updateDeck: CourseActions.updateDeck,
    removeDeck: CourseActions.removeDeck,
    refreshDeck: CourseActions.refreshDeck,
    refreshSectionStructure: CourseActions.refreshSectionStructure,
    createCard: CourseActions.createCard,
    updateCard: CourseActions.updateCard,
    moveCard: CourseActions.moveCard,
    removeCard: CourseActions.removeCard,
    createSubDeck: CourseActions.createSubDeck,
    updateSubDeck: CourseActions.updateSubDeck
  }
};